module.exports = __webpack_public_path__ + "img/Pot3.7b68fd20.svg";